import React from "react";
import { useNavigate } from "react-router-dom";
import UtilsUnit from "../../../utils/UtilsUnit";
import WidgetFilterDropdowns from "../../dropdowns/widget-filter-dropdowns/WidgetFilterDropdowns";
import WidgetSearchIcon from "../widget-search-icon/WidgetSearchIcon";
import { DivRow, WidgetMarginWidth } from "../../../styles/SharedStyles";

const WidgetSearchFrame = ({
  showSearchTerminal,
  handleSearchTerminalIconClick,
  uniqueDistricts,
  uniqueMunicipalities,
  uniqueTerminals,
  selectedDistrict,
  selectedMunicipality,
  selectedTerminal,
  handleSelectDropdownDistrict,
  handleSelectDropdownMunicipality,
  handleSelectDropdownTerminal,
  editMode = false,
}) => {
  const navigate = useNavigate();

  return (
    <DivRow>
      <WidgetSearchIcon showSearchTerminal={showSearchTerminal} handleSearchTerminalIconClick={handleSearchTerminalIconClick} editMode={editMode} />
      {showSearchTerminal ? (
        <DivRow>
          <WidgetMarginWidth width="0.6rem" />
          <div style={{ width: "23.8rem" }}>
            <WidgetFilterDropdowns
              uniqueDistricts={uniqueDistricts}
              uniqueMunicipalities={uniqueMunicipalities}
              uniqueTerminals={uniqueTerminals}
              selectedDistrict={selectedDistrict}
              selectedMunicipality={selectedMunicipality}
              selectedTerminal={selectedTerminal}
              handleSelectDropdownDistrict={handleSelectDropdownDistrict}
              handleSelectDropdownMunicipality={handleSelectDropdownMunicipality}
              handleSelectDropdownTerminal={handleSelectDropdownTerminal}
              handleSearchFrameClick={() => UtilsUnit.handleSearchFrameClick(navigate, selectedTerminal, editMode)}
              editModeProp={editMode}
              heightDropdownProp="4.5rem"
              gapDropdownProp="0.7rem"
              sizeIconProp="4.5rem"
            />
          </div>
        </DivRow>
      ) : (
        <div />
      )}
    </DivRow>
  );
};

export default WidgetSearchFrame;
